import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_TEST_REPORTS } from '@/api/endpoints';
import { TEST_REPORT_QUERY_KEY } from '@/api/queryKeys';
import type { TestReport } from '@/types/testReport';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useTestReport = (testId: number) =>
  useQuery({
    queryKey: [...TEST_REPORT_QUERY_KEY, testId],
    queryFn: () =>
      apiClient
        .get<TestReport>(`${API_TEST_REPORTS}/${testId}`)
        .then(unwrapAxiosResponse),
  });
